export default function PageHeader({ title, subtitle, action, className = "" }) {
  return (
    <div className={`pcard-page-header ${className}`.trim()}>
      <div>
        <h1 className="pcard-page-header__title">{title}</h1>
        {subtitle ? (
          <p className="pcard-page-header__subtitle">{subtitle}</p>
        ) : null}
      </div>
      {action || null}
    </div>
  );
}
